import { Breadcrumbs } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { IoCheckmarkCircleOutline } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { url } from '../configlink'

function Survey() {

    let [surveyData, setSurveyData] = useState({
        general_1: '',
        general_2: '',
        dQualityRating: '',
        dQualityComments: '',
        reportRating: '',
        reportComments: '',
        tatRating: '',
        tatComments: '',
        pricingRating:'',
        pricingComments:'',
        websiteRating: '',
        websiteComments: '',
        orderingRating: '',
        orderingComments: '',
        dropboxRating: '',
        dropboxComments: '',
        customerServiceRating: '',
        customerServiceComments: '',
        contactTheCustomer: 'Yes'
    })

    const user = useSelector((state) => state.user.user)

    let [surveyAnswered, setSurveyAnswered] = useState(false)
    let [buttonColor, setButtonColor] = useState(false)

    const [errors, setErrors] = useState({});
    
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0,100)
    },[])


    const validateSurvey = () => {
        const newErrors = {};

        if (!surveyData.general_1) newErrors.general_1 = 'Please Enter'

        if (!surveyData.general_2) newErrors.general_2 = 'Please Enter'

        if (!surveyData.dQualityComments) newErrors.dQualityComments = 'Please Enter'
        
        if (!surveyData.reportComments) newErrors.reportComments = 'Please Enter'
        
        if (!surveyData.tatComments) newErrors.tatComments = 'Please Enter'

        if (!surveyData.pricingComments) newErrors.pricingComments = 'Please Enter'
        
        if (!surveyData.websiteComments) newErrors.websiteComments = 'Please Enter'
        
        if (!surveyData.orderingComments) newErrors.orderingComments = 'Please Enter'

        if (!surveyData.dropboxComments) newErrors.dropboxComments = 'Please Enter'
        
        if (!surveyData.customerServiceComments) newErrors.customerServiceComments = 'Please Enter'

        return newErrors
    };

    
    function handleSurvey(){

        const validationErrors = validateSurvey();
        // console.log("here", validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors)
        }
        else {
            // console.log('PASS');
                        
            let data2 = {
                ...surveyData, 
                name: `${user.FirstName} ${user.LastName}`,
                email: user.EmailAddress,
                company: user.company,
            }

            // console.log(data2);

            setButtonColor(true)

            try {
                fetch(`${url}/api/orderForm/survey`, {
                method: "POST",
                credentials: 'include',
                headers: {
                    // Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data2),
                })
                .then(res => res.json())
                .then(data => {
                if(data.message === 'success'){
                    setSurveyAnswered(true)
                }
                setButtonColor(false)
                })
            } catch (error) {
                setButtonColor(false)
                console.log(error);
                
            } 
        }
    }
    

  return (
    <>
       <div className=' px-[16px] sm:px-[40px] xl:px-[128px]'>
        <div className="flex flex-col sm:flex-row justify-between items-center my-[40px] gap-[20px]">
          <h1 className='text-center sm:!text-left text-4xl text-[var(--color-primary-purple)] font-black '>
           Survey
          </h1>
        </div>
        
        {surveyAnswered ? 
            <div className="flex flex-col items-center gap-[10px] mt-10">
                <div className="flex items-center justify-center gap-[8px]">
                    <IoCheckmarkCircleOutline className='h-[36px] w-[36px] text-[#60C5C5]' />
                    <p className="text-center font-bold text-2xl text-[var(--color-primary-purple)]">Thank you for your response!</p>
                    {/* <div className="flex flex-col gap-[20px] w-[80%] mt-8">
                        <p className="text-center font-bold text-2xl text-[var(--color-primary-purple)]">Thank you for completing our survey.</p>
                        <p className='text-center font-bold text-lg'>Please check your inbox for a discount code which can be applied towards Sanger service. Enter this code in the Discount Code field of the Billing and Shipping checkout page. Should you have any questions please reach out to us at <a className='text-blue-800 underline' href="mailto:dnaseq@acgtinc.com">dnaseq@acgtinc.com</a>.</p>
                    </div> */}
                </div>
                <button
                className='mt-12 border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[289px] h-[43px] mb-16'
                onClick={() => navigate('/dashboard')}
                >
                    go back to account home
                </button>
            </div>
            :
            <div>
                <p className='text-2xl font-bold'>We want to hear from you!</p>
                <p className='text-lg mt-2'>Thank you for your recent order. ACGT is working hard to improve our service and your feedback is invaluable. We appreciate your time with the following survey and as always, feel free to reach out to us with any questions.</p>
            
                <div className='mt-5 flex flex-col gap-[80px] sm:px-16'>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>General</p>
                        <p className='text-lg'>1. Why do you sequence with ACGT? What distinguishes ACGT from other sequencing providers?</p>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.general_1} onChange={(e) => {
                            setErrors({...errors, general_1:''})
                            setSurveyData({...surveyData, general_1:e.target.value})
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.general_1 && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.general_1}</span>
                        )}
                        <p className='mt-[40px] text-lg'>2. How can we improve our services? Is there any service you would like to see ACGT offer?</p>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.general_2} onChange={(e) => {
                            setErrors({...errors, general_2:''})
                            setSurveyData({...surveyData, general_2:e.target.value})
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.general_2 && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.general_2}</span>
                        )}
                    </div>
                     <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Data Quality</p>
                        <p className='text-lg'>3. ACGT provides a high level of data quality.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.dQualityComments} 
                        onChange={(e) => {
                            setErrors({...errors, dQualityComments: ''})
                            setSurveyData({...surveyData, dQualityComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black w-full xl:w-[800px]' />
                        {errors.dQualityComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.dQualityComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Deliverables</p>
                        <p className='text-lg'>4. Data and/or report(s) are comprehensive and sufficient for my needs.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"NA"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>N/A</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.reportComments} onChange={(e) => {
                            setErrors({...errors, reportComments:''})
                            setSurveyData({...surveyData, reportComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.reportComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.reportComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Turnaround Times</p>
                        <p className='text-lg'>5. ACGT provides a rapid turnaround time, dependable and reliable.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.tatComments} onChange={(e) => {
                            setErrors({...errors, tatComments:''})
                            setSurveyData({...surveyData, tatComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.tatComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.tatComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Pricing</p>
                        <p className='text-lg'>6. ACGT sequencing services are reasonably and competitively priced.</p>
                        <div className='flex items-center gap-[10px]'>
							<input type="radio" name="pricing-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
							<p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
							<input type="radio" name="pricing-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
							<p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
							<input type="radio" name="pricing-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
							<p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
							<input type="radio" name="pricing-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
							<p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
							<input type="radio" name="pricing-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
							<p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.pricingComments} onChange={(e) => {
                            setErrors({...errors, pricingComments:''})
                            setSurveyData({...surveyData, pricingComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.pricingComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.pricingComments}</span>
                        )}
                    </div>


                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Website</p>
                        <p className='text-lg'>7. The website is easy to navigate, organized and has all resources needed to make informed decisions about ACGT&apos;s services.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="website-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, websiteRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="website-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, websiteRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="website-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, websiteRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="website-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, websiteRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="website-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, websiteRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="website-radio" value={"NA"} onChange={(e) => setSurveyData({...surveyData, websiteRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>N/A</p>
                        </div>
                       <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.websiteComments} onChange={(e) => {
                            setErrors({...errors, websiteComments:''})
                            setSurveyData({...surveyData, websiteComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.websiteComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.websiteComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Ordering & Checkout</p>
                        <p className='text-lg'>8. The dashboard and ordering forms are user friendly, intuitive and the checkout process is easy and convenient.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="ordering-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="ordering-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="ordering-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="ordering-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="ordering-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="ordering-radio" value={"NA"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>N/A</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.orderingComments} onChange={(e) => {
                            setErrors({...errors, orderingComments:''})
                            setSurveyData({...surveyData, orderingComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.orderingComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.orderingComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Dropboxes & Shipping</p>
                        <p className='text-lg'>9. Shipping my samples to ACGT is easy and convenient. Dropboxes are appropriately located at our campus.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"NA"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>N/A</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.dropboxComments} onChange={(e) => {
                            setErrors({...errors, dropboxComments:''})
                            setSurveyData({...surveyData, dropboxComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.dropboxComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.dropboxComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Customer Service</p>
                        <p className='text-lg'>10. Customer service is accessible, timely and responsive. The ACGT representative demonstrates knowledge and competence in resolving issues.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="customer-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, customerServiceRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="customer-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, customerServiceRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="customer-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, customerServiceRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="customer-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, customerServiceRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="customer-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, customerServiceRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="customer-radio" value={"NA"} onChange={(e) => setSurveyData({...surveyData, customerServiceRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>N/A</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.customerServiceComments} onChange={(e) => {
                            setErrors({...errors, customerServiceComments:''})
                            setSurveyData({...surveyData, customerServiceComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.customerServiceComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.customerServiceComments}</span>
                        )}
                    </div>

                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl'>By submitting this survey I consent to ACGT publishing my comment(s) on their website, or in marketing materials. ACGT will not identify me by my full name but may use my first name and last initial, title and/or institution.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="contact-radio" 
                            value={"Yes"}
                            checked={surveyData.contactTheCustomer === 'Yes'} 
                            onChange={(e) => setSurveyData({...surveyData, contactTheCustomer:e.target.value})} 
                            className='min-w-[20px] w-[20px] h-[20px]' />
                            <p className='text-lg'>Yes</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="contact-radio" 
                            value={"No"} 
                            checked={surveyData.contactTheCustomer === 'No'} 
                            onChange={(e) => setSurveyData({...surveyData, contactTheCustomer:e.target.value})} 
                            className='min-w-[20px] w-[20px] h-[20px]' />
                            <p className='text-lg'>No</p>
                        </div>
                    </div>

                    <div className='flex gap-[30px] justify-center sm:justify-start'>
                        <button
                        className={`border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[#302a7e] '} text-white uppercase min-w-[159px] h-[43px] mb-16`}
                        onClick={() => handleSurvey()}
                        >
                        Submit
                        </button>
                        <button
                        className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[159px] h-[43px] mb-16'
                        onClick={() => navigate('/dashboard')}
                        >
                        Cancel
                        </button>
                    </div>
                </div>
            </div>
        }   
      
      </div>
    </>
    
  )
}

export default Survey